// extracted by mini-css-extract-plugin
export default {"app":"AppLayout_app__B7M+T","adTop":"AppLayout_adTop__3rg1S","adBottom":"AppLayout_adBottom__qXfTE","content":"AppLayout_content__2HsNL"};